import { Controller } from "@hotwired/stimulus"
import { hideElement, showElement } from "../src/dom"
import { EventBus } from "../src/event_bus"

export default class extends Controller {
  static targets = [
    "iconCompleted",
    "iconFailed",
    "iconInProgress",
    "progressBar",
    "progressWrapper",
    "percentageDisplay",
    "messageCompleted"
  ]

  static values = {
    id: String,
    filename: String
  }

  initialize() {
    this.handleUploadError = this.handleUploadError.bind(this)
    this.handleUploadProgress = this.handleUploadProgress.bind(this)
    this.handleUploadSuccess = this.handleUploadSuccess.bind(this)
  }

  connect() {
    EventBus.on("video-upload:error", this.handleUploadError)
    EventBus.on("video-upload:progress", this.handleUploadProgress)
    EventBus.on("video-upload:success", this.handleUploadSuccess)
  }

  disconnect() {
    EventBus.off("video-upload:error", this.handleUploadError)
    EventBus.off("video-upload:progress", this.handleUploadProgress)
    EventBus.off("video-upload:success", this.handleUploadSuccess)
  }

  // Actions

  markAsCompleted() {
    showElement(this.iconCompletedTarget)
    hideElement(this.iconFailedTarget)
    hideElement(this.iconInProgressTarget)
    hideElement(this.progressWrapperTarget)

    showElement(this.messageCompletedTarget)
  }

  markAsFailed() {
    hideElement(this.iconCompletedTarget)
    hideElement(this.iconInProgressTarget)
    hideElement(this.messageCompletedTarget)

    showElement(this.iconFailedTarget)
  }

  updateProgress(progressPercentage) {
    if (!this.hasProgressBarTarget) { return }

    if (progressPercentage < 0) {
      this.markAsFailed()
      return
    }

    if (progressPercentage >= 100) { this.markAsCompleted() }

    this.progressBarTarget.style.width = `${progressPercentage}%`
    this.percentageDisplayTarget.innerHTML = this.formattedProgressPercentage(progressPercentage)
  }

  // Event handlers

  handleUploadError(payload) {
    if (payload.id !== this.id) { return }

    this.markAsFailed()
  }

  handleUploadProgress(payload) {
    if (payload.id !== this.id) { return }

    const progressEvent = payload.progressEvent
    const progressPercentage = Math.round((progressEvent.loaded * 100) / progressEvent.total)

    this.updateProgress(progressPercentage)
  }

  handleUploadSuccess(payload) {
    if (payload.id !== this.id) { return }

    this.updateProgress(100)
  }

  // Getters

  formattedProgressPercentage(progressPercentage) { return `${progressPercentage} %` }
  get id() { return this.idValue }
}
